<template>
  <div class="homePC">
    <div class="search_menu">
      <div class="menu_l">
        <div class="logo">
          <img src='../assets/logoh5.png'/>
        </div>
        <div class="search">
          <el-input placeholder="请输入位置查找内容" v-model="input" class="search_input" 
              clearable @keyup.enter.native="searchByHand" @input="searchByHand"  @clear="isshowAddress=false"/>
          <div @click="searchByHand" style="position: absolute;margin-left:315px;margin-top:11px">
            <i  class="el-icon-search iconfnt"></i>
          </div>
          <div class="search_btn" @click="city_select = !city_select,isshowAddress=false,isshowType=false">
            {{city_name}}
            <div class="search_btn_select" v-show="city_select">
              <div class="btn_head">当前区域：{{city_name}}</div>
              <div class="btn_menu">
                <span class="menu_item" v-for="(item,index) in hotCity" :key="index" @click="handel_hotcity(item)">
                  {{item.name}}
                </span>
              </div>
              <div class="btn_letter">
                <span class="letter_item" :class="active_letter === item ? 'isActive':''"
                      @click="active_letter = item;"
                      v-for="(item,index) in letterlist" :key="index">{{item}}</span>
              </div>
              <div class="btn_content">
                <div class="content_provice" v-for='(provice,index) in provice_citys' :key='index'>
                  <div class="provice_name"><span>{{provice.provice}}：</span></div>
                  <div class="content_city">
                    <span class="city_item" v-for='(city,index) in provice.cityList' :key='index' @click="handel_hotcity(city)">{{city.cityName}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="menu_r">
        <div class="menu">
          <div class="menu-item" :class="isActive === 1 ? 'isActive':''" 
              @click.stop="AllType(1)">
              全部 
              <div class="item_line" v-show='isActive === 1'></div>
          </div>
          <div class="menu-item" :class="isActive === 2 ? 'isActive':''"
              @click.stop="AllType(2,0)">
              VR全景
              <div class="item_line" v-show='isActive === 2'></div>
           </div>
          <div class="menu-item" :class="isActive === 3 ? 'isActive':''" 
              @click.stop="AllType(3,1)">
              全景视频
              <div class="item_line" v-show='isActive === 3'></div>
          </div>
        </div>
        <div class="btn" @click="public">去发布</div>
      </div>
    </div>
    <!-- 地址关键字搜索 -->
    <div class="address_box" v-show='isshowAddress' v-if='placeSearchList.length>0'>
       <div v-for='(item,index) in placeSearchList' :key='index' @click="select_address(item)" >
         <img src='../assets/daohang.png' />
         <span class="span1">{{ item.name }}</span>
         <span class="span2">{{ item.cityname }}</span>
       </div>
    </div>
    <div v-else class="address_box_nodata" v-show='isshowAddress'>
       暂无数据
    </div>
     <!-- 分类列表 -->
     <div class="search_three hotCity" v-show='isActive===2&&isshowType' >
            <div class="box" v-if='typelist.length>1'>
                <div v-for='(item,index) in typelist' :key='index' class="box_item">
                   <div :class="current_type_img===item.id?'liCol_blue':'liCol'" @click="handel_type(item,2,0)" v-show='item.name'>{{item.name}}</div>
                </div>
            </div>
            <el-row style="margin: 0px 0px 10px;" v-else>
              暂无数据
            </el-row>
      </div>
      <div class="search_three hotCity" v-show='isActive===3&&isshowType' >
           <div class="box" v-if='typelist_video.length>1'>
               <div  v-for='(item,index) in typelist_video' :key='index' class="box_item">
                  <div :class="current_type===item.id?'liCol_blue':'liCol'" @click="handel_type(item,3,1)" v-show='item.name'>{{item.name}}</div>
               </div>
           </div>
           <el-row style="margin: 0px 0px 10px;" v-else>
             暂无数据
           </el-row>
      </div>
    <!-- 地图 -->
    <div class="map_select" v-show='!is_search' v-loading="loading">
      <Amap :points='points' :longitude='longitude' :latitude='latitude' :zoom='zoom' @placeSearch='placeSearch' ref='amappage'></Amap>
    </div>
    <div class="recommend"  v-show="isshowrecommend">
      <div class="recommend_head">
        <div class="head_item">
          <div class="item_info" :class="showType === 1?'isActive':''" @click="showType = 1">精选推荐</div>
          <div class="item_info" :class="showType === 2?'isActive':''" @click="showType = 2">最新推荐</div>
        </div>
      </div>
      <div class="recommend_content">
        <div v-show='showType===1'>
          <div class="content_item" v-for='(item,index) in BoutiqueList' :key='index' @click="handle_click_item(item.linkUrl)">
            <div class="item_img">
              <img :src='item.coverImage' alt/>
              <div class="vrimgicon"><img src='../assets/VRimg.png'></div>
            </div>
            <div class="item_info">
              <div class="info_title">{{item.viewName}}</div>
              <div class="info_pos">
                <img src='../assets/daohang.png' style="width:12px;height: 12px;"/>
                {{item.cityName}} {{item.provinceName}}
              </div>
              <div class="line"></div>
              <div class="info_author">{{item.authorName}}</div>
            </div>
          </div>
        </div>
        <div v-show='showType===2'>
          <div class="content_item" v-for='(item,index) in NewList' :key='index' @click="handle_click_item(item.linkUrl)">
            <div class="item_img">
              <img :src='item.coverImage' alt/>
              <div class="vrimgicon"><img src='../assets/VRvideo.png'></div>
            </div>
            <div class="item_info">
              <div class="info_title">{{item.viewName}}</div>
              <div class="info_pos">
                <img src='../assets/daohang.png' style="width:12px;height: 12px;"/>
                {{item.cityName}}
              </div>
              <div class="line"></div>
              <div class="info_author">{{item.authorName}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="isshowrecommend?'openandclose':'isclose'" @click="isshowrecommend=!isshowrecommend">
       <img src='../assets/btnback.png' width="9px"></img>
    </div>
  </div>
</template>

<script>
import Amap from "../components/Amap"
import citylist from "../utils/city"
import provice_citys from "../utils/provice_citys"
import points  from "../utils/points"
export default {
  name: 'home',
  components:{ Amap },
  data: () => ({
    isActive: 1,
    spreadlist:[],
    select:'1',
    input:'',
    isarrow:false,
    isarrow2:false,
    isarrow3:false,
    isshowType:false, //是否展示分类
    isshowrecommend:true,//展开收起推荐
    city_name:'全国',
    city_select: false,
    hotCity: [
      {
        "name": "全国",
        "longitude": 104.174087,
        "latitude": 35.042644
      },
      {
        "name": "北京",
        "longitude": 116.322056,
        "latitude": 39.89491
      },
      {
        "name": "天津",
        "longitude": 117.201538,
        "latitude": 39.085294
      },
      {
        "name": "沈阳",
        "longitude": 123.465009,
        "latitude": 41.677287
      },
      {
        "name": "大连",
        "longitude": 121.618622,
        "latitude": 38.91459
      },
      {
        "name": "上海",
        "longitude": 121.473658,
        "latitude": 31.230378
      },
      {
        "name": "南京",
        "longitude": 118.796623,
        "latitude": 32.059352
      },
      {
        "name": "苏州",
        "longitude": 120.619585,
        "latitude": 31.299379
      },
      {
        "name": "杭州",
        "longitude": 120.209947,
        "latitude": 30.245853
      },
      {
        "name": "青岛",
        "longitude": 120.374402,
        "latitude": 36.168923
      },
      {
        "name": "郑州",
        "longitude": 113.783913,
        "latitude": 34.76239
      },
      {
        "name": "武汉",
        "longitude": 114.305215,
        "latitude": 30.592935
      },
      {
        "name": "长沙",
        "longitude": 112.938888,
        "latitude": 28.228272
      },
      {
        "name": "广州",
        "longitude": 113.264385,
        "latitude": 23.129112
      },
      {
        "name": "深圳",
        "longitude": 114.085947,
        "latitude": 22.547
      },
      {
        "name": "重庆",
        "longitude": 106.550464,
        "latitude": 29.563761
      },
      {
        "name": "成都",
        "longitude": 104.066143,
        "latitude": 30.573095
      },
      {
        "name": "西安",
        "longitude": 108.939621,
        "latitude": 34.343147
      },
      {
        "name": "香港",
        "longitude": 114.171202,
        "latitude": 22.277469
      },
      {
        "name": "澳门",
        "longitude": 113.583825,
        "latitude": 22.16252
      },
    ],
    active_letter: '',
    letterlist: ['A','F','G','H','J','L','N','Q','S','T','X','Y','Z'],
    typelist:[],//全景图分类
    typelist_video:[],//全景视频分类
    titlelist:[
        {id:1,value:'全部',col:6,top:'10px'},
        {id:2,value:'VR全景',col:9,top:'13px'},
        {id:3,value:'全景视频',col:9,top:'13px'},
    ],
    materialForm: {
        name: "",
        pos: [],
        posName: "",
        miniUrl: ""
    },
    citylist,
    provice_citys,
    //points:[],
    points,
    current_type:null,
    current_title:1,
    current_type_img:null,
    is_search:false,
    FristPin: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
    cityjson: [],
    alllist:[],
    show: false,
    show2: false,
    showType:1,  //1精品推荐  2最新推荐
    BoutiqueList:[],
    NewList:[],
    longitude:104.5525,
    latitude:34.3227,
    placeSearchList:[],
    isshowAddress:false,
    zoom:4,
    loading:false
  }),
  mounted() {
      this.sortCity()
      this.cityAll()
      this.typeListdata(0)
      this.typeListdata(1)
      this.recommenddata()
      this.newdata()
  },
  methods: {
      //点击分类菜单
      AllType(active,vrType){
        this.isActive = active;
        this.isshowType = true,
        this.city_select = false,
        this.isshowAddress = false
        let id = vrType===0?this.current_type_img:this.current_type
        this.cityAll(id,vrType)
      },
      //去发布
      public(){
        window.open("https://wmy.ophyer.com/")
      },
      handle_click_item(linkUrl){
        console.log(linkUrl)
        window.open(linkUrl);
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
       //回显关键字搜索list
       placeSearch(item){
          console.log(JSON.parse(JSON.stringify(item)),'item')
          let data = JSON.parse(JSON.stringify(item))
          this.isshowAddress = true
          this.placeSearchList = data
       },
       //点击选择关键字搜索的具体值
       select_address(item){
          console.log(item,'itemhhhhh' )
          this.isshowAddress = false
          this.input = item.name
          let location = JSON.parse(JSON.stringify(item.location))
          this.longitude = location.lng
          this.latitude = location.lat
          this.zoom = 16
       },
       //根据关键字去地图获取地址列表
       searchByHand() {  
          this.isshowType = false
          this.city_select = false
          if(this.input){
             this.is_search = false
             this.$refs.amappage.searchByHand(this.input);
          }
      },

      handel_hotcity(item,type){
        console.log(item,'item')
        this.is_search = false
        this.isarrow = false
        this.zoom = item.value==='全国'?8:11

        this.city_name = item.name?item.name:item.cityName
        this.longitude = parseInt(item.longitude)
        this.latitude  = parseInt(item.latitude)
        console.log(this.zoom,'this.zoom')
      },
      
      //1选择精品  2选择最新
      handelRecommend( val ){
           this.showType = val
      },
      //推荐展开收起
      showVuePopup(flag,val) {
          this.show2 = flag
          this.showType = val
      },
      //城市首字母定位
      goIndex(params) {
        const groupRef = this.$refs.groupRef 
        const titleRef = this.$refs.titleRef 
        titleRef.map((item) => {
          if (item.innerText === params) {
            groupRef.scrollTo({
              top: item.offsetTop,
              behavior: 'smooth' // 平滑移动
            })
          }
        })
      },
      
      sortCity(){

        let cityJsons = {};
        var cityJsondata= [];
        //根据首字母键值对给原数据按首字母分类
        let _this = this
        for (let i = 0; i < _this.FristPin.length; i++) {   
            cityJsons[_this.FristPin[i]] = this.citylist.filter(function (value) {
                return value.letter === _this.FristPin[i];
            })
        }
        //整合按照首字母分类
        cityJsons = Object.values(cityJsons);
        for (let j = 0; j <cityJsons.length; j++) { 
          for (let p = 0; p < _this.FristPin.length; p++) {    
            if(p===j){
               cityJsondata.push({title:_this.FristPin[p],children:cityJsons[j]})
            }    
          }  
        }
        _this.cityjson =cityJsondata;
        //console.log(this.cityjson,'this.cityjson')
      },
      handelselect (data) {
        console.log(data, 'data')
      }, 
      //获取全国VR城市分部列表
      cityAll(item,vrType){
        //let devurl = 'http://122.115.53.160:8815/city/view/all'
        let devurl = 'https://vrworld.ophyer.com/api/city/view/all'
        let param ={
          typeId:item?item.id:'',
          vrType:vrType
        }
        //let url = process.env.NODE_ENV==='development'?  devurl:(process.env.NODE_ENV==='test'?'https://vrworld.igame123.com/backend/apiProxy/city/view/all':'https://vrworld.ophyer.com/backend/apiProxy/city/view/all')
        this.$axios.get(devurl,{ params: param }).then((res) =>{
             console.log(res.data.errMsg,'res')  
             if(res.data.errMsg){
                this.$message.error(res.data.errMsg)
             }      
             else{
                this.points = res.data.data
             }      
        })
      },
      
      //通过分类查询地图
      typecity(id,vrType){
        let devurl = 'https://vrworld.ophyer.com/api/city/view'
        let param ={
          typeId:id,
          pageNum:1,
          pageSize:9999,
          viewType:vrType
        }
        
        //let url = process.env.NODE_ENV==='development'?  devurl:(process.env.NODE_ENV==='test'?'https://vrworld.igame123.com/backend/apiProxy/city/view/all':'https://vrworld.ophyer.com/backend/apiProxy/city/view/all')
        this.$axios.get(devurl,{ params: param }).then((res) =>{     
             if(res.data.errMsg){
                this.$message.error(res.data.errMsg)
             }      
             else{
                this.points = res.data.data.records
                this.longitude = 116,
                this.latitude = 39,
                this.zoom = 5
             }  
        })
      },
      //分类列表
      typeListdata(type){
        let devurl ='https://vrworld.ophyer.com/api/city/type/listByViewType?type='+type
       // let url = process.env.NODE_ENV==='development'?  devurl:(process.env.NODE_ENV==='test'?'https://vrworld.igame123.com/backend/apiProxy/city/view/all':'https://vrworld.ophyer.com/backend/apiProxy/city/view/all')
        this.$axios.get(devurl).then((res) =>{
             if(res.data.errMsg){
                this.$message.error(res.data.errMsg)
             } 
             else{
                if(type===0){
                  this.typelist = res.data.data
                  let item = {
                    id: null,
                    name: "全部"
                  }
                  this.typelist.unshift(item)
                }      
                else{
                  let item = {
                    id:null,
                    name: "全部"
                  }
                  this.typelist_video = res.data.data
                  this.typelist_video.unshift(item)
                }  
             }
             //console.log(this.typelist,'this.typelist')
        })
      },
      handel_type(item,type,vrType){
          console.log(item,'item')
          this.loading = false
          //this.typecity(item.id,item.vrType)
          this.cityAll(item,vrType)
          this.isshowType = false
          if(type===2){
             this.isarrow2 = false
             this.current_type_img = item.id
          }
          if(type===3){
             this.isarrow3 = false
             this.current_type = item.id
          }
          // else{
          //   this.current_type = ''
          // }
          this.loading = false
          // this.longitude = item.longitude
          // this.latitude  = item.latitude
          // this.zoom = 8
      },
      handel_title(item){
          if(item.id===2){
             this.isarrow2 = !this.isarrow2
             this.isarrow3 = this.isarrow2?false:this.isarrow3
             this.isshowType = this.isarrow2
             //this.typeListdata(0)
          }
          if(item.id===3){
             this.isarrow3 = !this.isarrow3
             this.isarrow2 = this.isarrow3?false:this.isarrow2
             this.isshowType = this.isarrow3
             //this.typeListdata(1)
          }
          if(item.id===1){
            //  this.isarrow2 = false
            //  this.isshowType = false
             this.cityAll()
          }
          this.current_title = item.id  
      },
      //获取推荐数据
      recommenddata(){
        //let devurl = 'http://122.115.53.160:8815/city/view/all'
        let devurl = 'https://vrworld.ophyer.com/api/city/view/recommend'
        let param ={
          viewType:0,
          pageNum:1,
          pageSize:10
        }
        //let url = process.env.NODE_ENV==='development'?  devurl:(process.env.NODE_ENV==='test'?'https://vrworld.igame123.com/backend/api/city/view/recommend':'https://vrworld.ophyer.com/backend/api/city/view/recommend')
        this.$axios.get(devurl,{ params:param }).then((res) =>{ 
             if(res.data.errMsg){
                this.$message.error(res.data.errMsg)
             }  
             else{
              console.log(res.data)
                this.BoutiqueList = res.data.data;
             }                
        })
      },

      //获取最新数据
      newdata(){
        //let devurl = 'http://122.115.53.160:8815/city/view/all'
        let devurl = 'https://vrworld.ophyer.com/api/city/view/new'
        //let url = process.env.NODE_ENV==='development'?  devurl:(process.env.NODE_ENV==='test'?'https://vrworld.igame123.com/backend/apiProxy/city/view/all':'https://vrworld.ophyer.com/backend/apiProxy/city/view/all')
        this.$axios.get(devurl).then((res) =>{ 
             if(res.data.errMsg){
                this.$message.error(res.data.errMsg)
             }  
             else{
              console.log(res.data)
                this.NewList = res.data.data
             }                
        })
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
.homePC{
  /* 定义滚动条样式 */
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(144,147,153,.3);
    transition: background-color .3s;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(144,147,153, .5);
  }
  ::v-deep .search_menu{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    margin-top: -12px;
    .menu_l{
      width: 630px;
      display: flex;
      .logo{
        width: 160px;
        display: flex;
        margin-left: 20px;
        img{
          width: 100%;
          object-fit: contain;
        }
      }
      .search{
        width: 425px;
        display: flex;
        margin-left: 20px;
        .search_input{
          width: 345px;
          height: 40px;
        }
        .el-input__suffix {
          .el-icon-circle-close:before {
            position: absolute;
            margin-left: -33px !important;
          }
        }
        .search_btn{
          margin-left: 10px;
          width: 70px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: #F4F6F9;
          border-radius: 5px;
          font-size: 14px;
          color: #606469;
          position: relative;
          .search_btn_select{
            position: absolute;
            top: 40px;
            left: 0px;
            width: 465px;
            height: 350px;
            background: #FFFFFF;
            box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.06);
            border-radius: 0px 0px 5px 5px;
            padding-right: 1px;
            z-index: 999;
            .btn_head{
              width: 100%;
              height: 40px;
              background: #F4F6F9;
              padding: 0 20px;
              text-align: left;
              font-size: 14px;
              color: #303234;
            }
            .btn_menu{
              width: 100%;
              padding: 6px 20px;
              text-align: left;
              line-height: 12px;
              .menu_item{
                display: inline-block;
                width: 40px;
                text-align: left;
                font-size: 12px;
                color: #2F88FF;
                margin-top: 10px;
              }
            }
            .btn_letter{
              width: 100%;
              text-align: left;
              padding: 0 20px;
              line-height: 12px;
              margin-top: 10px;
              .letter_item{
                display: inline-block;
                margin-right: 6px;
                width: 18px;
                height: 18px;
                background: #F4F6F9;
                border-radius: 3px;
                font-size: 12px;
                color: #606469;
                text-align: center;
                line-height: 18px;
                cursor: pointer;
              }
              .isActive{
                background: linear-gradient(90deg, #5CBDFF 0%, #2F88FF 100%);
                box-shadow: 0px 2px 5px 0px rgba(42, 118, 221, 0.24);
                color: #FFFFFF;
              }
            }
            .btn_content{
              width: 100%;
              margin-top: 20px;
              line-height: 1;
              height: calc(100% - 150px);
              overflow-y: auto;
              .content_provice{
                width: calc(100% - 40px);
                //height: 55px;
                display: flex;
                padding: 0 20px;
                .provice_name{
                  width: 40px;
                  font-size: 12px;
                  font-weight: bold;
                  color: #303234;
                  padding-top: 2px;
                }
                .content_city{
                  width: 100%;
                  text-align: left;
                  .city_item{
                    display: inline-block;
                    font-size: 12px;
                    color: #606469;
                    cursor: pointer;
                    margin-bottom: 8px;
                    margin-right: 16px;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
        .el-input__inner{
          background-color: #F4F6F9 !important;
        }
      }
    }
    .menu_r{
      width: 405px;
      display: flex;
      margin-right: 20px;
      .menu{
        display: flex;
        align-items: center;
        width: 100%;
        .menu-item{
          flex-grow: 1;
          width: 0;
          .item_line{
             width: 24px;
             height: 3px;
             background: #2F88FF;
             border-radius: 2px;
             text-align: center;
             margin-left: 43px;
             margin-top: 15px;
             position: absolute;
          }
        }
        .isActive{
           color: #2F88FF;
           cursor: pointer;
        }
      }
      .btn{
        width: 100px;
        height: 40px;
        background: linear-gradient(90deg, #5CBDFF 0%, #2F88FF 100%);
        box-shadow: 0px 2px 5px 0px rgba(42, 118, 221, 0.24);
        border-radius: 20px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        color: #FFFFFF;
      }
    }
  }
  .recommend{
    position: fixed;
    left: 20px;
    top: 80px;
    width: 345px;
    height: calc(100vh - 110px);
    background: #FFFFFF;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.04);
    border-radius: 5px;
    .recommend_head{
      width: 100%;
      height: 72px;
      display: flex;
      align-items: center;
      justify-content: center;
      .head_item{
        width: 208px;
        height: 42px;
        background: #F4F6F9;
        border-radius: 21px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 5px;
        .item_info{
          font-size: 15px;
          color: #606469;
          width: 90px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          cursor: pointer;
        }
        .isActive{
          background: #FFFFFF;
          border-radius: 16px;
          font-size: 15px;
          font-weight: bold;
          color: #2F88FF;
        }
      }
    }
    .recommend_content{
      padding: 10px 16px;
      height: calc(100vh - 210px);
      overflow-y: auto;
      .content_item{
        width: 100%;
        height: 80px;
        margin-bottom: 25px;
        display: flex;
        cursor: pointer;
        .item_img{
          // width: 108px;
          // height: 100%;
          position: relative;
          margin: 0 12px;
          img{
            width: 100%;
            height: 100%;
            object-fit: contain;
            border-radius: 5px;
          }
          .vrimgicon{
            width: 24px;
            height: 24px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
          }
        }
        .item_info{
          margin-left: 12px;
          text-align: left;
          .line{
            height: 1px;
            background: #E8E9EC;
            border-radius: 2px;
            margin-top: 10px;
            width: 193px;
          }
          .info_title{
            margin-top: 5px;
            font-size: 15px;
            color: #333333;
          }
          .info_pos{
            margin-top: 5px;
            font-size: 12px;
            color: #989EA6;
            display: flex;
            align-items: center;
          }
          .info_author{
            font-size: 12px;
            color: #989EA6;
            margin-top: 6px;
          }
        }
      }
    }
  }
}
.openandclose{
   position: absolute;
   width: 22px;
   height: 42px;
   background: #FFFFFF;
   box-shadow: 4px 0px 4px 0px rgb(0 0 0 / 4%);
   border-radius: 0px 5px 5px 0px;
   left: 365px;
   top: 99px;
   img{
     margin-top: 15px;
   }
}
.isclose{
   position: absolute;
   width: 22px;
   height: 42px;
   background: #FFFFFF;
   box-shadow: 4px 0px 4px 0px rgb(0 0 0 / 4%);
   border-radius: 0px 5px 5px 0px;
   left: 0px;
   top: 99px;
   img{
     margin-top: 15px;
   }
}

.all{
  display: flex;
  margin: 0 auto 7px;
  width: 100%;
  .left{
    margin-left: 15px;
    img{
      width: 125.42px;
    }
  }
  .right{
    position: absolute;
    right: 15px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606469;
    span{
      vertical-align: top;
      line-height: 16px;
      img{
        width: 10px;
      }
    }
  }
}
.vrlist{
    position: absolute;
    z-index: 999;
    background-color: white;
    width: 100%;
    overflow: hidden;
}
::v-deep .head{
  display: flex;
  margin: 0 auto;
  background: #F4F6F9;
  border-radius: 20px;
  height: 40px;
  width: 94%;
  .left{
    width: 70px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606469;
    line-height: 48px;
    img{
      width: 32px;
    }
  }
  .right{
    position: absolute;
    right: 30px;
    line-height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606469;
    span{
      // vertical-align: top;
      // line-height: 16px;
      img{
        width: 10px;
      }
    }
  }
  .el-input{
    margin-left: -33px !important;
  }
 .el-input__inner{
    border: 0px solid #DCDFE6 !important;
    border-radius: 0px !important; 
    background-color: #F4F6F9 !important;
    padding: 0 10px;
    background: #F4F6F9 !important;
  }
  .iconfnt{
    font-size: 16px;
    margin-top: 13px;
    margin-left: 20px;
  }
}

.address_box{
    position: absolute;
    z-index: 9999;
    text-align: left;
    padding: 10px 15px 0;
    width: 345px;
    height: 336px;
    background: #FFFFFF;
    box-shadow: 0px 4px 6px 0px rgb(0 0 0 / 10%);
    border-radius: 5px;
    margin-left: 200px;
    margin-top: -9px;
    div{
      padding: 0 0 14px;
      cursor: pointer;
      // border-block-end: 1px solid #F0F2F6;
    }
    img{
      width: 12px;
    }
    .span1{
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #303234;
      line-height: 20px;
      margin: 0 10px;
    }
    .span2{
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #989EA6;
      line-height: 17px;
    }
}
.address_box_nodata{
    position: absolute;
    z-index: 9999;
    text-align: left;
    padding: 10px 15px 0;
    width: 345px;
    height: 36px;
    background: #FFFFFF;
    box-shadow: 0px 4px 6px 0px rgb(0 0 0 / 10%);
    border-radius: 5px;
    margin-left: 200px;
    margin-top: -9px;
}
.warps1{
    width: 100%;
    height: 40px;
    background: #F4F6F9;
    margin: 0px auto 15px;
    line-height: 40px;
    float: left;
    text-align: left;
    padding-left: 15px;
}
.hotCity{
  h3{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #989EA6;
    margin-left: 15px;
    text-align: left;
  }
  .liCol{
    height: 32px;
    background: #F4F6F9;
    border-radius: 5px;
    margin-bottom: 8px;
    line-height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #303234;
  }
  .liCol_blue{
    background: linear-gradient(90deg, #5CBDFF 0%, #2F88FF 100%);
    box-shadow: 0px 2px 5px 0px rgba(42, 118, 221, 0.24);
    height: 32px;
    border-radius: 5px;
    margin-bottom: 8px;
    line-height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
  }
  .box{
    margin: 0 auto;
    width: 355px;
  }
}
.search_two{
   margin: 0px 0 9px;
   span{
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #606469;
      line-height: 20px;
   }
   img{
     width: 10px;
     vertical-align: top;
     margin-top: 8px;
   }
}
.search_three{
  //  margin-top: 14px;
   border-block-start: 1px solid #E8E9EC;
  //  position: absolute;
   background: #fff;
   width: 1500px;
   .box{
      display: flex;
      width: 100%;
      margin: 0 auto;
      z-index: 99;
      position: absolute;
      background: #fff;
      padding: 20px 30px 10px;
      text-align: center;
      flex-wrap: wrap;
   }
   .box_item{
    //  width: 90px;
     margin: 0px 8px 0 0;
    //  padding: 10px 20px;
   }
  .liCol{
    height: 32px;
    background: #F4F6F9;
    border-radius: 5px;
    margin-bottom: 8px;
    line-height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #303234;
    padding: 0 20px;
  }
  .liCol_blue{
    background: linear-gradient(90deg, #5CBDFF 0%, #2F88FF 100%);
    box-shadow: 0px 2px 5px 0px rgba(42, 118, 221, 0.24);
    height: 32px;
    border-radius: 5px;
    margin-bottom: 8px;
    line-height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
    padding: 0 20px;
  }
}


.div-container {
     text-align: left;
     margin-left: 15px;
     margin-top: 22px;
    .group-content {
      height: 500px;
      position: relative;
      bottom:20px;
      height: calc(100vh - 260px);
      .group-list-container {
        height: 100%;
        overflow: auto;
        .group-list {
          margin-bottom: 16px;
          .list-title {
             margin:20px 0 1px;
             font-size: 14px;
             font-family: PingFangSC-Regular, PingFang SC;
             font-weight: 400;
             color: #989EA6;
          }
        }
      }

      .word-list {
        position: absolute;
        right: 19px;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 500px;
        font-size: 12px;
        font-weight: 400;
        color: #3e4451;
        div {
          text-align: center;
          cursor: pointer;
        }
      }

   .Cname{
     font-size: 16px;
     font-family: PingFangSC-Regular, PingFang SC;
     font-weight: 400;
     color: #303234;
     border-bottom: 1px solid #f0f2f6;
     padding-bottom: 18px;
     padding-top: 13px;
   }
   .pin{
     font-size: 12px;
     font-family: PingFangSC-Medium, PingFang SC;
     font-weight: 500;
     color: #303234;
     line-height: 17px;
   }
    }
}

.xn-container {
    //height: 100%;
    .footer_box{
      width: 42px;
      height: 85px;
      position:absolute;
      bottom: 70px;
      right: 12px;
      background: #FFFFFF;
      box-shadow: 0px 0px 7px 0px rgba(0, 92, 193, 0.3);
      border-radius: 5px;
      .ft_button1{
        margin-top: 6px;
      }
      .ft_button2{
        margin-top: -11px;
      }
      img{
        width: 22px;
      }
      p{
         font-size: 16px;
         font-family: PingFangSC-Regular, PingFang SC;
         font-weight: 400;
         color: #303234;
         line-height: 16px;
         margin-top: -6px;
         -webkit-transform: scale(0.5);
         transform: scale(0.5);
        // width: 64px;
        // margin-left: -11px;
         width: 80px;
         margin-left: -18px;
      }
      .row_box{
        margin: 0 auto;
        text-align: center;
      }
    }

}

.vue-popup {
    .close{
       width: 40px;
       height: 4px;
       background: rgba(0, 0, 0, 0.3);
       border-radius: 2px;
       position: absolute;
       top: -12px;
       margin: 0px auto;
       text-align: center;
       left: 45%;
    }
    .popup-content {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        -webkit-transition: all 0.2s ease-in;
        transition: all 0.2s ease-in;
        height: 478px;
        background: linear-gradient(180deg, #FFFFFF 0%, #F4F6F9 100%);
        box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.04);
        border-radius: 20px 20px 0px 0px;
        z-index: 99999;
        // overflow: auto;
        p {
            line-height: 30px;
            text-align: center;
        }
        .button_box{
            display: flex;
            width: 208px;
            height: 42px;
            background: #F4F6F9;
            border-radius: 21px;
            margin: 9px auto 0;
            .button_box1{
               width: 90px;
               height: 32px;
               background: #FFFFFF;
               border-radius: 16px;
               margin: 0 6px;
               line-height: 35px;
               margin-top: 5px;
               color: #2F88FF;
            }
            .button_box2{
               width: 90px;
               height: 32px;
               border-radius: 16px;
               margin: 0 6px;
               line-height: 35px;
               margin-top: 5px;
            }
        }
        .img_box{
            margin: 15px auto 0;
            width: 167px;
            height: 220px;
            background: #FFFFFF;
            border-radius: 5px;
            img{
               width: 167px;
               object-fit:cover;
               height: 125px;
               border-radius: 5px 5px 0 0;
            }
            .wenzi_box{
              margin-left: 10px;
              margin-top: -32px;
               .sub{
                   font-size: 12px;
                   font-family: PingFangSC-Regular, PingFang SC;
                   font-weight: 400;
                   color: #989EA6;
                   margin-top: -10px;
                   text-align: left;
                   img{
                      position: absolute;
                      margin-top: 3px;
                   }
                   span{
                     margin-left: 13px;
                   }
               }
               .line{
                 margin-top: 8px;
                 width: 147px;
                 height: 1px;
                 background: #E8E9EC;
                 border-radius: 2px;
               }
               p{
                 font-size: 12px;
                 font-family: PingFangSC-Regular, PingFang SC;
                 font-weight: 400;
                 color: #989EA6;
                 line-height: 12px;
                 text-align: left
               }
               h2{
                 white-space: nowrap;// 文字不换行
                 overflow: hidden;// 超出隐藏
                 text-overflow: ellipsis;
                 width: 142px;
                 font-size: 14px;
                 font-family: PingFangSC-Medium, PingFang SC;
                 font-weight: 500;
                 color: #333333;
                 line-height: 20px;
                 text-align: left;
              }
            } 
        }
        .row_box{
            overflow: auto;
            height: 425px;
            margin: 0 8px;
        }
    }
}
.mask {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    // background-color: rgba(0, 0, 0, 0.4);
    transition: all 0.2s ease-in;
}
 
.slide-enter-active {
    animation-name: slideInUp;
    animation-duration: 0.2s;
    animation-fill-mode: both;
}
.slide-leave-active {
    animation-name: slideOutDown;
    animation-duration: 0.2s;
    animation-fill-mode: both;
}
@keyframes slideInUp {
    0% {
        transform: translate3d(0, 100%, 0);
        visibility: visible;
    }
 
    to {
        transform: translateZ(0);
    }
}
@keyframes slideOutDown {
    0% {
        transform: translateZ(0);
    }
 
    to {
        visibility: hidden;
        transform: translate3d(0, 100%, 0);
    }
}
.delay-leave-active {
    -webkit-animation-delay: 0.2s;
    -moz-animation-delay: 0.2s;
    -o-animation-delay: 0.2s;
    animation-delay: 0.2s;
}

::v-deep #container {
   height: calc(100vh - 63px) !important; 
}
</style>
